
import React from 'react';
import { Tab, Tabs, Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { mnrTabIndex } from '../../Redux/TabIndexSlice';
import { isMNR } from '../../Redux/MNR/MNRCommonSlice';
import EligibleMemberByPlanYear from './MemberByPlanYear';
import GroupByMemberAll from './GroupByMemberAll';
import DupeQA from './DupeQA';
import Formulary from './Formulary';
import PAPriceDetail from "./PAPriceDetail";
import PACompoundDetail from './PACompoundDetail';
import PriorAuth from './PriorAuth';
import ProductDetail from './ProductDetail';
import CodeSet from './CodeSet';
import { reportsTabIndex } from '../../Redux/TabIndexSlice';
import {clearData as memberByPlanYear} from "../../Redux/MNR/MemberByPlanYearSlice";
import {clearData as groupByMember} from  "../../Redux/MNR/GroupByYearAllSlice";
import {clearData as dupeQA} from  "../../Redux/MNR/DupeQASlice";
import {clearData as formulary} from  "../../Redux/MNR/FormularySlice";
import {clearData as priorAuth} from  "../../Redux/MNR/PriorAuthSlice";
import {clearData as paCompoundDetail} from  "../../Redux/MNR/PACompoundDetailSlice";
import {clearData as paPriceDetail} from  "../../Redux/MNR/PAPriceDetailSlice";
import {clearData as productDetail} from "../../Redux/MNR/ProductDetailSlice";
import {clearData as codeSet} from "../../Redux/MNR/CodeSetSlice";

function MNRBase() {
    const dispatch = useDispatch();
    const tab = useSelector(state => state.tab.mnrTab);
    const mnr = useSelector(state => state.role.mnr);

    const handleMnrTabIndexChange = (e, value) => {
        dispatch(mnrTabIndex(value));
        dispatch(isMNR(true));
        dispatch(reportsTabIndex(0));
        dispatch(memberByPlanYear());
        dispatch(groupByMember());
        dispatch(dupeQA());
        dispatch(formulary());
        dispatch(priorAuth());
        dispatch(paCompoundDetail());
        dispatch(paPriceDetail());
        dispatch(productDetail());
        dispatch(codeSet());
    }

    const renderContent = () => {
        switch (tab) {
            case 0:
                return <EligibleMemberByPlanYear />;
            case 1:
                return <GroupByMemberAll />
            case 2:
                return <DupeQA />;
            case 3:
                return <Formulary />;
            case 4:
                return <PriorAuth />;
            case 5:
                return <PACompoundDetail />;
            case 6:
                return <PAPriceDetail />;
            case 7:
                return <ProductDetail />;
            case 8:
                return <CodeSet />;
            default:
                break;
            // return <EligibleMemberByPlanYear />;
        }
    }

    return (
        <>
            <Box display="flex" alignItems="flex-start" sx={{ paddingLeft: '0px', background: 'rgb(251, 249, 244)' }}>
                <Tabs
                    value={tab}
                    onChange={handleMnrTabIndexChange}
                    variant="scrollable"
                    style={{ paddingLeft: '8px' }}
                    TabIndicatorProps={{
                        sx: {
                            backgroundColor: 'var(--secondary-color)',
                        },
                    }}
                >
                    <Tab label="Plan Year All"
                        style={{
                            fontSize: 'var(--font-size-header)',
                            fontFamily: 'var(--font-family-base)',
                        }}
                        sx={{
                            color: 'inherit',
                            '&.Mui-selected': {
                                color: 'var(--secondary-color)',
                            },
                        }} />
                    <Tab label="Group By Year All" style={{
                        fontSize: 'var(--font-size-header)',
                        fontFamily: 'var(--font-family-base)',
                    }}
                        sx={{
                            color: 'inherit',
                            '&.Mui-selected': {
                                color: 'var(--secondary-color)',
                            },
                        }} />
                    <Tab label="Dupe QA" style={{
                        fontSize: 'var(--font-size-header)',
                        fontFamily: 'var(--font-family-base)',
                    }}
                        sx={{
                            color: 'inherit',
                            '&.Mui-selected': {
                                color: 'var(--secondary-color)',
                            },
                        }} />
                    <Tab label="Formulary" style={{
                        fontSize: 'var(--font-size-header)',
                        fontFamily: 'var(--font-family-base)',
                    }}
                        sx={{
                            color: 'inherit',
                            '&.Mui-selected': {
                                color: 'var(--secondary-color)',
                            },
                        }} />
                    <Tab label="Prior Auth" style={{
                        fontSize: 'var(--font-size-header)',
                        fontFamily: 'var(--font-family-base)',
                    }}
                        sx={{
                            color: 'inherit',
                            '&.Mui-selected': {
                                color: 'var(--secondary-color)',
                            },
                        }} />
                    <Tab label="PA Compound Detail" style={{
                        fontSize: 'var(--font-size-header)',
                        fontFamily: 'var(--font-family-base)',
                    }}
                        sx={{
                            color: 'inherit',
                            '&.Mui-selected': {
                                color: 'var(--secondary-color)',
                            },
                        }} />
                    <Tab label="PA Price Detail" style={{
                        fontSize: 'var(--font-size-header)',
                        fontFamily: 'var(--font-family-base)',
                    }}
                        sx={{
                            color: 'inherit',
                            '&.Mui-selected': {
                                color: 'var(--secondary-color)',
                            },
                        }} />
                    <Tab label="PA Product" style={{
                        fontSize: 'var(--font-size-header)',
                        fontFamily: 'var(--font-family-base)',
                    }}
                        sx={{
                            color: 'inherit',
                            '&.Mui-selected': {
                                color: 'var(--secondary-color)',
                            },
                        }} />
                    <Tab label="Code set" style={{
                        fontSize: 'var(--font-size-header)',
                        fontFamily: 'var(--font-family-base)',
                    }}
                        sx={{
                            color: 'inherit',
                            '&.Mui-selected': {
                                color: 'var(--secondary-color)',
                            },
                        }} />

                </Tabs>
            </Box>
            <Box style={{ padding: mnr ? '24px' : '0 0 0 0' }}>
                {renderContent()}
            </Box>
        </>
    )
}

export default MNRBase